import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PlatosEmblematicos from "./sections/PlatosEmblematicos";
import NuestraEsencia from "./sections/NuestraEsencia";
import Experiencia from "./sections/Experiencia";
import BarDeCoctelesYMezcal from "./sections/BarDeCoctelesYMezcal";
import VistaDelMenu from "./sections/VistaDelMenu";
import Testimonios from "./sections/Testimonios";
import ReservasYUbicacion from "./sections/ReservasYUbicacion";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <PlatosEmblematicos />
      <NuestraEsencia />
      <Experiencia />
      <BarDeCoctelesYMezcal />
      <VistaDelMenu />
      <Testimonios />
      <ReservasYUbicacion />
      <Footer />
    </div>;
}